import React from 'react';
import { Tabs, Card } from 'antd';
import { API_BASE_URL } from '../constants';

const { TabPane } = Tabs;

const CodeBlock = ({ language, code }) => (
  <Card className="code-block" bordered={false}>
    <pre>
      <code className={`language-${language}`}>{code}</code>
    </pre>
  </Card>
);

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const getMethodName = (method, isSDK = false) => {
  if (isSDK) {
    return method.toLowerCase() === 'get' ? 'list' : method.toLowerCase();
  }
  return method;
};

const getSDKPath = (endpoint) => {
  const parts = endpoint.split('/').filter(Boolean);
  return parts.map(capitalize).join('.');
};

export const ApiExample = ({ endpoint, method = 'GET', params = null, response = null }) => {
  const curlParams = params ? Object.entries(params)
    .map(([key, desc]) => `  -d ${key}="${desc.example}"`).join(' \\\n') : '';

  const nodeParams = params ? Object.entries(params)
    .reduce((acc, [key, desc]) => ({ ...acc, [key]: desc.example }), {}) : null;

  const pythonParams = params ? Object.entries(params)
    .reduce((acc, [key, desc]) => `    "${key}": "${desc.example}"${acc ? ',\n' + acc : ''}`, '') : '';

  return (
    <Tabs defaultActiveKey="curl">
      <TabPane tab="cURL" key="curl">
        <CodeBlock
          language="bash"
          code={`curl ${API_BASE_URL}${endpoint} \\
  -X ${method} \\
  -H "x-api-key: Bearer zk_test_your_api_key"${params ? ' \\' : ''}
${curlParams}`}
        />
      </TabPane>
      <TabPane tab="Node.js" key="nodejs">
        <CodeBlock
          language="javascript"
          code={`const https = require('https');

const options = {
  hostname: '${API_BASE_URL.replace('https://', '')}',
  path: '${endpoint}',
  method: '${method}',
  headers: {
    'x-api-key': 'Bearer zk_test_your_api_key'
  }
};${params ? `\n\nconst data = ${JSON.stringify(nodeParams, null, 2)};\n` : ''}
const req = https.request(options, (res) => {
  let data = '';

  res.on('data', (chunk) => {
    data += chunk;
  });

  res.on('end', () => {
    console.log(JSON.parse(data));
  });
});${params ? `\n\nreq.write(JSON.stringify(data));` : ''}
req.end();`}
        />
      </TabPane>
      <TabPane tab="Python" key="python">
        <CodeBlock
          language="python"
          code={`import http.client
import json

conn = http.client.HTTPSConnection("${API_BASE_URL.replace('https://', '')}")
headers = {
    'x-api-key': 'Bearer zk_test_your_api_key'
}${params ? `\n\ndata = {\n${pythonParams}\n}` : ''}

conn.request("${method}", "${endpoint}", ${params ? 'json.dumps(data), ' : 'None, '}headers)
response = conn.getresponse()
data = response.read()

print(json.loads(data.decode("utf-8")))
conn.close()`}
        />
      </TabPane>
      {response && (
        <TabPane tab="Response" key="response">
          <CodeBlock
            language="json"
            code={JSON.stringify(response, null, 2)}
          />
        </TabPane>
      )}
    </Tabs>
  );
}; 